import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { getProperty } from 'utils';

import { useStaticShared } from 'hooks';

import styles from './gbv-logo.module.scss';

export const GbvLogo = ({ size = 'sm' }) => {
	const staticShared = useStaticShared();

	const data = getProperty(staticShared, 'data.gbv.0') || {};
	const src = getProperty(data, 'logo.0.localFile.publicURL');

	const wrapperClassName = useMemo(
		() => [styles.wrapper, styles[size]].join(' '),
		[size]
	);

	return (
		<a
			href={data.url}
			target="_blank"
			rel="noreferrer noopener"
			className={wrapperClassName}>
			<img className={styles.svg} src={src} alt={data.title} />
		</a>
	);
};

GbvLogo.propTypes = {
	size: PropTypes.oneOf(['sm', 'lg']),
};
